import React from "react"
import { PageForm, Delimiter } from "client/components"

import Main from "./main"
import FailureRate from "./failureRate"
import Probability from "./probability"
import Percentage from "./percentage"

const MainSettings = () => (
    <PageForm>
        <Main />

        <Delimiter size="sm" />

        <FailureRate />
        <Probability />
        <Percentage />
    </PageForm>
)
export default MainSettings
